import axios from 'axios';

export const INOPACK_REST_API_URL = 'http://localhost:3008';
export const inopackAxios = axios.create({
    baseURL: INOPACK_REST_API_URL,
});
